











import Vue from 'vue';

export enum OpenState {
  Unopened,
  Opened,
  Flagged,
}

export default Vue.extend({
  props: {
    mineState: {
      type: Number,
    },
    height: {
      type: Number,
    },
    width: {
      type: Number,
    },
    openState: {
      type: Number,
    },
  },
  computed: {
    isOpened(): boolean {
      return this.openState === OpenState.Opened;
    },
    isFlagged(): boolean {
      return this.openState === OpenState.Flagged;
    },
    getClass(): {
      unopened: boolean;
      flagged: boolean;
      opened: boolean;
    } {
      return {
        unopened: this.openState === OpenState.Unopened,
        flagged: this.isFlagged,
        opened: this.isOpened,
      };
    },
  },
  methods: {
    leftClick(): void {
      switch (this.openState) {
        case OpenState.Unopened:
          this.$emit('openBlock', this.height, this.width);
          break;
        case OpenState.Flagged:
          break;

        case OpenState.Opened:
          this.$emit('openBlock', this.height, this.width);
          break;

        default:
        //
      }
    },
    rightClick(): void {
      switch (this.openState) {
        case OpenState.Unopened:
        case OpenState.Flagged:
          this.$emit('setFlag', this.height, this.width);
          break;
        default:
        //
      }
    },
  },
});
